<template>
  <div class="row">
    <div class="col-12">
      <h2>{{ $t('platform_packages.create') }}</h2>
    </div>

    <div class="col-12 mt-4">
      <form class="row" @submit.prevent="createPlatformPackage">
        <FormFields v-model:formData="formData"/>
        <div class="col-12 mt-3 d-flex gap-2">
          <button class="btn btn-success" type="submit" :disabled="saving">
            {{ $t('save') }}
          </button>
          <router-link class="btn btn-outline-secondary" :to="{name: ROUTES.PLATFORM_PACKAGES.INDEX}">
            {{ $t('close') }}
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {usePlatformPackageStore} from '@/stores/platform_package'
import {Helpers} from '@/helpers'
import {ROUTES} from '@/scripts/constants'
import FormFields from '@/pages/platform_packages/components/FormFields.vue'
import {errorMessages, platformPackagePayload} from '@/pages/platform_packages/helpers'

export default {
  name: 'PlatformPackagesCreate',
  components: {FormFields},
  setup() {
    return {
      platformPackageStore: usePlatformPackageStore(),
    }
  },
  data() {
    return {
      formData: {
        base_type: 'unterkunft',
        source_kind: 'paid',
        quantity: 1,
        price: 0,
        price_per_extra_quantity: 0,
        ends_at: '',
      },
      saving: false,
    }
  },
  computed: {
    ROUTES() {
      return ROUTES
    },
  },
  created() {
    this.setTitle(this.$t('platform_packages.create'))
  },
  methods: {
    createPlatformPackage() {
      this.saving = true
      this.platformPackageStore.create(platformPackagePayload(this.formData)).then(() => {
        Helpers.emitter.emit('success', this.$t('platform_packages.created'))
        this.$router.push({name: ROUTES.PLATFORM_PACKAGES.INDEX})
      }).catch((error) => {
        Helpers.emitter.emit('error', errorMessages(error))
      }).finally(() => {
        this.saving = false
      })
    },
  },
}
</script>
